import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { isString, isEmpty } from 'lodash-es'
import ReactTooltip from 'react-tooltip'
import Section from '../../Section'

const HashContainer = styled.li`
  margin-bottom: 7px;
  transition: 0.22s;

  &:hover {
    code {
      background-color: #e1e4ef;
    }
  }

  .__react_component_tooltip {
    font-family: 'SFMono' !important;
    max-width: 570px !important;
  }
`

const Hash = ({ hash, filename }) => (
  <HashContainer>
    <code data-tip="" data-for={hash}>
      {hash.substring(0, 3)}...
      {hash.substring(hash.length - 3, hash.length)} {'./' + filename}
    </code>
    <ReactTooltip id={hash} getContent={() => hash} />
  </HashContainer>
)

Hash.propTypes = {
  hash: PropTypes.string,
  filename: PropTypes.string,
}

const Appendix = ({ report: { reportContent } }) => (
  <Section title="Appendix">
    <div>
      <h4>File Signatures</h4>
      <p>
        The following are the SHA-256 hashes of the reviewed files. A file with a different SHA-256
        hash has been modified, intentionally or otherwise, after the security review. You are
        cautioned that a different SHA-256 hash could be (but is not necessarily) an indication of a
        changed condition or potential vulnerability that was not within the scope of the review.
      </p>
    </div>
    {!isEmpty(reportContent.breakdownAndAutomatedAnalysis.contractHashes) &&
      !isString(reportContent.breakdownAndAutomatedAnalysis.contractHashes) && (
        <div>
          <h4>Contracts</h4>
          <ul>
            {reportContent.breakdownAndAutomatedAnalysis.contractHashes.map(contract => (
              <Hash
                key={`${contract.hash}-${contract.name}`}
                hash={contract.hash}
                filename={contract.name}
              />
            ))}
          </ul>
        </div>
      )}
    {!isEmpty(reportContent.breakdownAndAutomatedAnalysis.testsHashes) &&
      !isString(reportContent.breakdownAndAutomatedAnalysis.testsHashes) && (
        <div>
          <h4>Tests</h4>
          <ul>
            {reportContent.breakdownAndAutomatedAnalysis.testsHashes.map(test => (
              <Hash key={`${test.hash}-${test.name}`} hash={test.hash} filename={test.name} />
            ))}
          </ul>
        </div>
      )}
  </Section>
)

Appendix.propTypes = {
  report: PropTypes.object,
}

export default Appendix
